import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';

import { Event, EventRecruitmentFormat, RecruitmentFormat } from '../models';
import * as fromStore from '../store';

@Component({
    selector: 'event-info-editor',
    templateUrl: './event-info-editor.component.html',
})
export class EventInfoEditorComponent implements OnInit, OnDestroy {
    alive = true;
    event$: Observable<Event>;
    event: Event;
    panelState$: Observable<fromStore.PanelState>;
    panelState: fromStore.PanelState;
    editor: FormGroup;
    format: EventRecruitmentFormat;
    changeEvent = new EventEmitter<any>();
    selectedValue: number;

    eventTypes: any[] = [
        { id: 1, name: 'Rental Event' },
        { id: 7, name: 'Recruitment Event *NEW*' },
        { id: 2, name: 'Step Up Event' },
        { id: 3, name: 'Instrument Fitting' },
        { id: 4, name: 'Instrumental Demonstration' },
        { id: 6, name: 'Other' }
    ];

    recruitmentFormats: RecruitmentFormat[] = [
        { id: 1, name: 'Info/Pres/Demo In-Person' },
        { id: 2, name: 'Info/Pres/Demo Digital' },
        { id: 3, name: 'Instrument Fitting' },
        { id: 4, name: 'Be Part of the Music' }
    ];

    selectedFormats: RecruitmentFormat[] = [];
    selectAllControl: FormControl;

    constructor(private store: Store<fromStore.EventsState>, private fb: FormBuilder) {
        console.log('EventInfoEditorComponent()...');
        this.selectAllControl = new FormControl(false);
    }

    ngOnInit() {
        console.log('EventInfoEditorComponent.ngOnInit()...');

        this.event$ = this.store.pipe(select(fromStore.getDetailsStateEvent));
        this.event$.pipe(
            takeWhile(() => this.alive)
        ).subscribe(d => this.event = d);

        this.panelState$ = this.store.pipe(select(fromStore.getDetailsStateEventInfoPanel));
        this.panelState$.pipe(
            takeWhile(() => this.alive),
            tap(s => {
                if (!s.editing && this.panelState && this.panelState.editing) {
                    console.log('EventInfoEditorComponent.panelState$: clearing form...');
                    this.resetForm();
                }
            }),
        ).subscribe(s => this.panelState = s);

        this.selectedValue = this.event.eventTypeId;
        this.createForm();
    }

    get canSave(): boolean {
        return this.editor.valid && this.editor.dirty && !this.panelState.updating;
    }

    ngOnDestroy() {
        console.log('EventInfoEditorComponent.ngOnDestroy()...');
        this.alive = false;
    }

    createForm() {
        this.editor = this.fb.group({
            isActive: [this.isActive],
            name: [this.event.name, Validators.required],
            note: [this.event.note],
            eventType: [this.event.eventTypeId, Validators.required],
            check1: [this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 1)],
            check2: [this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 2)],
            check3: [this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 3)],
            check4: [this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 4)],
        });
    }

    resetForm() {
        this.editor.reset({
            isActive: [this.isActive],
            name: this.event.name,
            note: this.event.note,
            eventType: this.event.eventTypeId,
            check1: this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 1),
            check2: this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 2),
            check3: this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 3),
            check4: this.event.eventRecruitmentFormats.find(itm => itm.recruitmentFormatId == 4),
        });
    }

    onSelectChange(event: MouseEvent) {
    }
    get isActive() {
        return this.event.isActive ? 'Yes' : 'No';
    }

    onSubmit() {
        const isActive = this.editor.value.isActive === 'Yes';
        const name = this.editor.value.name;
        const note = this.editor.value.note;
        const eventTypeId = this.editor.value.eventType;
        const eventRecruitFormats: EventRecruitmentFormat[] = [];

        if (this.editor.value.check1) {
            eventRecruitFormats.push({ eventId: this.event.id, recruitmentFormatId: this.recruitmentFormats[0].id });
        }
        if (this.editor.value.check2) {
            eventRecruitFormats.push({ eventId: this.event.id, recruitmentFormatId: this.recruitmentFormats[1].id });
        }
        if (this.editor.value.check3) {
            eventRecruitFormats.push({ eventId: this.event.id, recruitmentFormatId: this.recruitmentFormats[2].id });
        }
        if (this.editor.value.check4) {
            eventRecruitFormats.push({ eventId: this.event.id, recruitmentFormatId: this.recruitmentFormats[3].id });
        }

        const event: Event = {
            ...this.event,
            isActive,
            name,
            note,
            eventTypeId,
            eventRecruitmentFormats: eventRecruitFormats
        };

        this.store.dispatch(new fromStore.UpdateEventPanel({ panel: fromStore.PanelId.EventInfo, event }));

    }

    onSelectAll(e: MouseEvent) {
        const selected: boolean = (e.target as HTMLInputElement).checked;

        this.editor.get('check1').setValue(selected);
        this.editor.get('check2').setValue(selected);
        this.editor.get('check3').setValue(selected);
        this.editor.get('check4').setValue(selected);
    }
}
